/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ok_Grand_Firefox_IntendInputs */

const fr_ok_grand_firefox_intend = /** @type {(inputs: Ok_Grand_Firefox_IntendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe oublié ?`)
};

/**

* @param {Ok_Grand_Firefox_IntendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const ok_grand_firefox_intend = /** @type {((inputs?: Ok_Grand_Firefox_IntendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ok_Grand_Firefox_IntendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_ok_grand_firefox_intend(inputs)
});